(function () {
  'use strict';

  class PzPizetalabCarousel {
    constructor(el) {
      this.el = el;
      this.list = el.querySelector('.pz-pizetalab__list');
      this.items = Array.from(el.querySelectorAll('.pz-pizetalab__item'));
      this.prevBtn = el.querySelector('[data-pz-prev]');
      this.nextBtn = el.querySelector('[data-pz-next]');
      this.dotsWrap = el.querySelector('[data-pz-dots]');
      this.live = el.querySelector('[data-pz-live]');
      this.autoplay = el.dataset.autoplay === 'true';
      this.interval = parseInt(el.dataset.autoplayInterval, 10) || 5000;
      this.currentPage = 0;
      this.timer = null;
      this.pageSize = 1;

      if (!this.list || this.items.length === 0) return;

      this.computePageSize();
      this.buildDots();
      this.bindEvents();
      this.updateUI();

      if (this.autoplay && !this.prefersReducedMotion()) this.startAutoplay();
    }

    prefersReducedMotion() {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    itemStride() {
      const first = this.items[0];
      if (!first) return 1;
      const rect = first.getBoundingClientRect();
      const gap = parseFloat(getComputedStyle(this.list).columnGap || getComputedStyle(this.list).gap || 0) || 0;
      return rect.width + gap;
    }

    computePageSize() {
      const stride = this.itemStride();
      const listWidth = this.list.clientWidth;
      this.pageSize = Math.max(1, Math.round(listWidth / stride));
    }

    pageCount() {
      return Math.max(1, Math.ceil(this.items.length / this.pageSize));
    }

    buildDots() {
      if (!this.dotsWrap) return;
      this.dotsWrap.innerHTML = '';
      const pages = this.pageCount();
      for (let p = 0; p < pages; p++) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'pz-pizetalab__dot';
        dot.setAttribute('role', 'tab');
        dot.setAttribute('aria-label', 'Vai alla pagina ' + (p + 1) + ' di ' + pages);
        dot.addEventListener('click', () => { this.goToPage(p, true); this.pauseAutoplay(); });
        this.dotsWrap.appendChild(dot);
      }
    }

    bindEvents() {
      if (this.prevBtn) this.prevBtn.addEventListener('click', () => { this.prev(); this.pauseAutoplay(); });
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => { this.next(); this.pauseAutoplay(); });

      this.list.addEventListener('scroll', () => {
        window.clearTimeout(this._sto);
        this._sto = window.setTimeout(() => this.syncFromScroll(), 120);
      }, { passive: true });

      this.el.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') { e.preventDefault(); this.prev(); this.pauseAutoplay(); }
        if (e.key === 'ArrowRight') { e.preventDefault(); this.next(); this.pauseAutoplay(); }
        if (e.key === 'Home') { e.preventDefault(); this.goToPage(0, true); this.pauseAutoplay(); }
        if (e.key === 'End') { e.preventDefault(); this.goToPage(this.pageCount() - 1, true); this.pauseAutoplay(); }
      });

      this.el.addEventListener('mouseenter', () => this.stopAutoplay());
      this.el.addEventListener('mouseleave', () => { if (this.autoplay && !this._userPaused) this.startAutoplay(); });
      this.el.addEventListener('focusin', () => this.stopAutoplay());
      this.el.addEventListener('focusout', (e) => {
        if (!this.el.contains(e.relatedTarget) && this.autoplay && !this._userPaused) this.startAutoplay();
      });

      window.addEventListener('resize', () => {
        window.clearTimeout(this._rto);
        this._rto = window.setTimeout(() => {
          const prev = this.pageSize;
          this.computePageSize();
          if (this.pageSize !== prev) {
            this.buildDots();
            this.currentPage = Math.min(this.currentPage, this.pageCount() - 1);
          }
          this.updateUI();
        }, 150);
      });
    }

    syncFromScroll() {
      const maxScroll = this.list.scrollWidth - this.list.clientWidth;
      const pages = this.pageCount();
      if (maxScroll <= 0 || pages <= 1) return;
      const ratio = this.list.scrollLeft / maxScroll;
      const p = Math.round(ratio * (pages - 1));
      if (p !== this.currentPage) {
        this.currentPage = p;
        this.updateUI();
      }
    }

    goToPage(p, announce) {
      const pages = this.pageCount();
      this.currentPage = Math.max(0, Math.min(p, pages - 1));

      let targetLeft = 0;
      if (this.currentPage >= pages - 1) {
        targetLeft = this.list.scrollWidth - this.list.clientWidth;
      } else {
        const firstItem = this.items[this.currentPage * this.pageSize];
        if (firstItem) {
          targetLeft = firstItem.offsetLeft - this.list.offsetLeft;
        }
      }

      this.list.scrollTo({
        left: Math.max(0, targetLeft),
        behavior: this.prefersReducedMotion() ? 'auto' : 'smooth',
      });
      this.updateUI(announce);
    }

    prev() {
      const pages = this.pageCount();
      const p = this.currentPage - 1;
      this.goToPage(p < 0 ? pages - 1 : p, true);
    }

    next() {
      const pages = this.pageCount();
      const p = this.currentPage + 1;
      this.goToPage(p >= pages ? 0 : p, true);
    }

    updateUI(announce) {
      const pages = this.pageCount();
      if (this.prevBtn) this.prevBtn.disabled = this.currentPage <= 0 && !this.autoplay;
      if (this.nextBtn) this.nextBtn.disabled = this.currentPage >= pages - 1 && !this.autoplay;
      if (this.dotsWrap) {
        Array.from(this.dotsWrap.children).forEach((dot, p) => {
          if (p === this.currentPage) {
            dot.setAttribute('aria-current', 'true');
            dot.setAttribute('aria-selected', 'true');
          } else {
            dot.removeAttribute('aria-current');
            dot.setAttribute('aria-selected', 'false');
          }
        });
      }
      if (announce && this.live) {
        this.live.textContent = 'Pagina ' + (this.currentPage + 1) + ' di ' + pages;
      }
    }

    pauseAutoplay() {
      this._userPaused = true;
      this.stopAutoplay();
    }

    startAutoplay() {
      if (this.prefersReducedMotion()) return;
      this.stopAutoplay();
      this.timer = window.setInterval(() => this.next(), this.interval);
    }

    stopAutoplay() {
      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    }
  }

  function init(root) {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-pz-carousel]').forEach((el) => {
      if (el.__pzInit) return;
      el.__pzInit = true;
      new PzPizetalabCarousel(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
